"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Handles exporting image data to a zip file.
 *
 * @param {Object} groupImageData - An object containing image data grouped by image ID.
 * @returns {Promise<JSZip>} - A Promise that resolves with a JSZip instance containing exported images.
 *
 * @example
 *
 * // Example usage:
 * const groupImageData = {
 *    id01: {
 *      ref: () => {}, // Function to get is2u file
 *      DATA: {
 *        img: {}, // Image data
 *        json: {} // Image info
 *      }
 *    },
 *    id02: {
 *      ref: () => {}, // Function to get is2u file
 *      DATA: {
 *        img: {}, // Image data
 *        json: {} // Image info
 *      }
 *    }
 * };
 * const zipFile = await handleImageExport(imageData);
 * zipFile.generateAsync({ type: 'blob' }).then(content => {
 *    // Use content.blob to download the zip file
 * });
 */ "default", {
    enumerable: true,
    get: function() {
        return handleImageExport;
    }
});
const _jszip = /*#__PURE__*/ _interop_require_default(require("jszip"));
const _ = require(".");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const downloadFile = (file)=>{
    const url = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.name || `export_${Date.now()}.zip`;
    link.click();
    URL.revokeObjectURL(url);
};
async function handleImageExport(groupImageData = {}) {
    const zip = new _jszip.default();
    for (const [id, data = {}] of Object.entries(groupImageData)){
        if (!id) return;
        const { DATA = {} } = data;
        const { img = {}, json = {}, exportImage } = DATA;
        // Create a folder for each image ID
        const imageFolder = zip.folder(id);
        imageFolder.file(`info.json`, JSON.stringify(json));
        // convert preview to blob -->
        const preview = img.src;
        const previewBuffer = (0, _.dataURIToArrayBuffer)(preview);
        const imageBlob = new Blob([
            previewBuffer
        ]);
        imageFolder.file(`preview.jpeg`, imageBlob);
        // export an .is2 if valid callback -->
        if (exportImage) {
            // pack updated is2 using valid IRRenderer instance
            const file = await exportImage(json, previewBuffer);
            if (file) {
                imageFolder.file(`${id}.IS2`, file);
            }
        }
    }
    const zipBlob = await zip.generateAsync({
        type: "blob"
    });
    downloadFile(zipBlob);
}
